import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import { useSubscribeMutation, useGetProfileQuery, useUpdateMutation, useCheckstripesubscriptionMutation, useSubscribeinstripeMutation } from '../../slices/students/studentsApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';


const StudentAfterPayment = () => {
    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { id } = useParams();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const [stripeid, setStripeid] = useState();
    const [subscription, setSubscription] = useState();

    useEffect(() => {
        if(studentInfo) {
            const subscription = studentInfo?.questions.find(sub => sub.plan === id);
            setStripeid(subscription?.stripe_subscription_id)
        }
    }, [studentInfo])

    const [checkstripesubscription, { data2, error2, isLoading2 }] = useCheckstripesubscriptionMutation();

    useEffect( () => {
        if (stripeid) {
            const fetchData = async () => {
            const res = await  checkstripesubscription({id, stripeid}).unwrap();
            dispatch(setStudentCredentials({ ...res.updatedStudent }));
            }
            fetchData();
        }
        setTimeout(() => {
            navigate("/studentasknew");
          }, 4000);
    }, [stripeid])

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br />
            <div className="container-fluid mt--5 loginResponsive"><br />  
                <Loader />
            </div>
        </div>      
    </div>
  )
}

export default StudentAfterPayment
